import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel, Country, OrderCreateModel, State } from '../../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-billing-address-order-card',
    templateUrl: './billing-address-order-card.component.html',
    styleUrl: './billing-address-order-card.component.scss',
    standalone: false,
})
export class BillingAddressOrderCardComponent implements OnInit {
  @Input() order: OrderCreateModel = new OrderCreateModel();
  @Input() countries: Country[] = [];
  @Input() states: State[] = [];
  @Output() nextStep = new EventEmitter<void>();
  @Output() countryId = new EventEmitter<number>();
  decorativeLineVisible: boolean = false;

  ngOnInit() {
    if (!this.order.address) {
      this.order.address = new AddressModel();
    }
  }

  isAnyFieldFilled(): boolean {
    return !!this.order.address.country  || !!this.order.address.state?.trim() || !!this.order.address.city?.trim() || !!this.order.address.postalCode?.trim() || !!this.order.address.street?.trim() || !!this.order.address.firstname?.trim() || !!this.order.address.lastname?.trim() || !!this.order.address.phone?.trim() || !!this.order.address.email?.trim();
  }
  
  isFormValid(): boolean {
    return !!this.order.address.country && !!this.order.address.state && !!this.order.address.city && !!this.order.address.postalCode && !!this.order.address.street;
  }

  removeAll() {
    Object.assign(this.order.address, {country: '', state: '', city: '', postalCode: '', street: '', firstname: '', lastname: '', phone: '', email: '' });
  }

  openNextStep() {
    this.decorativeLineVisible = true;
    this.nextStep.emit();
  }

  addAddressCountry(event: string) {
    const selectedCountry = this.countries.find(country => country.name == event);

    this.countryId.emit(selectedCountry.id);
  }

}
